export const filterArray = [
  {
    id: 1,
    name: "Business Analyst",
    value: "business_analyst",
  },

  {
    id: 2,
    name: "Product Owner",
    value: "product_owner",
  },

  {
    id: 3,
    name: "Scrum Master",
    value: "scrum_master",
  },
  {
    id: 4,
    name: "AA-PDM",
    value: "aa_product_manager",
  },
  {
    id: 5,
    name: "Landing Page",
    value: "landing_page",
  },
  {
    id: 6,
    name: "TAC-ICP",
    value: "icp",
  },
  {
    id: 7,
    name: "TAC-ICP-APO",
    value: "apo",
  },
  {
    id: 8,
    name: "TAC-PDM",
    value: "product_manager",
  },
];

export const filterArrayForTAC = [
  {
    id: 2,
    name: "ICP",
    value: "icp",
  },
  {
    id: 5,
    name: "ICP-APO",
    value: "apo",
  },
  {
    id: 1,
    name: "PDM",
    value: "product_manager",
  },
  {
    id: 6,
    name: "APM",
    value: "agile_project_management",
  },
  {
    id: 4,
    name: "ICP-ACC",
    value: "icp_acc",
  },
  {
    id: 3,
    name: "ATF",
    value: "agile_team_facilitator",
  },
      {
    id: 7,
    name: "SELF-APM",
    value: "self_apm",
  },
 
];
